import { useState } from "react";
import { npcContacts } from "../../../mocks/inbox";

interface ComposeModalProps {
  onClose: () => void;
}

export default function ComposeModal({ onClose }: ComposeModalProps) {
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [sent, setSent] = useState(false);

  const handleSend = () => {
    if (!to || !subject || !body.trim()) return;
    setSent(true);
    setTimeout(() => {
      onClose();
    }, 1500);
  };

  if (sent) {
    return (
      <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
        <div className="bg-[#1C1F2E] border border-[#00C896]/50 rounded-2xl px-8 py-6 text-center">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#00C896]/20 mx-auto mb-3">
            <i className="ri-check-line text-[#00C896] text-2xl"></i>
          </div>
          <p className="text-[#111111] font-semibold">메일이 발송되었습니다</p>
          <p className="text-[#8B91A8] text-xs mt-1">AI 답변을 기다려 주세요</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-end sm:items-center justify-center p-4">
      <div className="w-full max-w-xl bg-[#1C1F2E] border border-[#2A2D3E] rounded-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#252830]">
          <h3 className="text-[#111111] font-semibold text-sm flex items-center gap-2">
            <i className="ri-mail-add-line text-[#E8375F]"></i>
            새 메일 작성
          </h3>
          <button onClick={onClose} className="text-[#5A5E72] hover:text-white cursor-pointer">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="p-5 space-y-3">
          <div>
            <label className="text-[#5A5E72] text-xs block mb-1">수신인</label>
            <select
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="w-full bg-[#252830] text-sm text-white rounded-lg px-3 py-2.5 outline-none border border-transparent focus:border-[#E8375F]/50 cursor-pointer"
            >
              <option value="">거래처 선택...</option>
              {npcContacts.map((npc) => (
                <option key={npc.id} value={npc.id}>
                  {npc.name} ({npc.company})
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-[#5A5E72] text-xs block mb-1">제목</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="메일 제목을 입력하세요"
              className="w-full bg-[#252830] text-sm text-white rounded-lg px-3 py-2.5 outline-none border border-transparent focus:border-[#E8375F]/50 placeholder-[#5A5E72]"
            />
          </div>

          <div>
            <label className="text-[#5A5E72] text-xs block mb-1">내용</label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              placeholder="메일 내용을 작성하세요..."
              maxLength={500}
              rows={6}
              className="w-full bg-[#252830] text-sm text-white rounded-lg px-3 py-2.5 outline-none border border-transparent focus:border-[#E8375F]/50 placeholder-[#5A5E72] resize-none"
            />
            <div className="text-[#5A5E72] text-[10px] text-right">{body.length}/500</div>
          </div>
        </div>

        <div className="px-5 pb-5 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-[#8B91A8] text-sm border border-[#2A2D3E] hover:border-[#3E4155] transition-colors cursor-pointer whitespace-nowrap"
          >
            취소
          </button>
          <button
            onClick={handleSend}
            disabled={!to || !subject || !body.trim()}
            className="px-5 py-2 rounded-lg bg-[#E8375F] hover:bg-[#d42e52] text-white text-sm font-medium disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-send-plane-fill mr-1.5"></i>
            발송하기
          </button>
        </div>
      </div>
    </div>
  );
}
